import React, { Component, useEffect, useRef, useState } from "react";

import ProductsSelectWithFilter from "@/components/common/filters/ProductsSelectWithFilter";
import { getDefaultUnit } from "@/components/PurchaseOrders/newPurchaseOrderModal/AddPurchaseProductModal";
import { setProductsUnits } from "@/store/actions";
import instance from "@/store/actions/instance";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, Input, Select, Table, message } from "antd";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import InventoryExcelUploader from "@/components/StockUpdateOrders/StockUpdateOrderDetailsModal/InventoryExcelUploader";

const { Column } = Table;
const { Option } = Select;
const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  return (
    <EditableContext.Provider>
      <tr {...props} />
    </EditableContext.Provider>
  );
};

const EditableCell = ({
  editable,
  children,
  record,
  handleSave,
  direction,
  value,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = (e) => {
    toggleEdit();
    if (e.target.value && e.target.value !== value) handleSave(e.target.value);
  };

  if (editable) {
    children = editing ? (
      <Input
        defaultValue={value}
        ref={inputRef}
        onPressEnter={save}
        onBlur={save}
        style={{ direction: direction }}
        min={0}
      />
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {value}
      </div>
    );
  }

  return <td {...restProps}>{children}</td>;
};
class ProductionOrderProductsTable extends Component {
  state = { loading: false, excelModalOpen: false };

  fetchProductsUnits = async (productsIds) => {
    const { t } = this.props;
    try {
      this.setState({ loading: true });
      const res = await instance.post(`/get_products_units/`, { productsIds });
      this.props.setProductsUnits(res.data);
      this.setState({ loading: false });
      return res.data;
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ loading: false });
  };
  addProduct = (product) => {
    const { units, allProducts } = this.props;
    const selectedProduct = allProducts.find(
      (p) => p.id === product.product_id,
    );

    if (!selectedProduct) return null;
    let productUnits =
      selectedProduct?.units?.filter((u) => !u.is_deleted) || [];

    let baseUnit = units.find((u) => u.id === selectedProduct.unit);
    let unit = productUnits.find((u) => u.unit_id === product.unit_id);
    baseUnit = {
      ...baseUnit,
      unit__name: baseUnit?.name,
      unit__ar_name: baseUnit?.ar_name,
      conversion_factor: 1,
      unit_id: baseUnit?.id || null,
    };

    return {
      product__name: selectedProduct.name,
      product__ar_name: selectedProduct.ar_name,
      product__sku: selectedProduct.sku || "",
      id: selectedProduct.id,
      product_id: selectedProduct.id,
      key: selectedProduct.id,
      quantity: product.quantity,
      baseUnit: baseUnit,
      conversion_factor: unit?.conversion_factor || 1,
      unit:
        unit ||
        getDefaultUnit(productUnits || [], baseUnit, "default_for_production"),
      units: productUnits || [],
      type: "new-create",
    };
  };
  renderColumnDelete = (text, record, index) => {
    return (
      <Button
        disabled={record.type == "New"}
        onClick={() => {
          const newProducts = [...this.props.products];
          if (newProducts[index].type === "new-create") {
            newProducts.splice(index, 1);
          } else {
            newProducts[index].is_deleted = true;
          }
          this.props.setProducts(newProducts);
        }}
        danger
        shape="circle"
        icon={<DeleteOutlined style={{ top: 0 }} />}
      ></Button>
    );
  };
  renderColumnProduct = (productId, record, index) => {
    const { t, config, products } = this.props;
    if (record.type !== "New") {
      return (
        <span style={{ whiteSpace: "break-spaces" }}>
          {`${
            (config.language === "arabic" && record.product__ar_name) ||
            record.product__name
          } ${record.product__sku} `}
        </span>
      );
    }
    const currentProductsIds = products
      .filter((p) => !p.is_deleted)
      .map((p) => p.product_id);
    return (
      <ProductsSelectWithFilter
        loading={this.state.loading}
        onSelect={async (newSelectedProduct) => {
          const selectedProduct = this.props.allProducts.find(
            (p) => p.id === newSelectedProduct,
          );
          const newProducts = [...this.props.products];
          if (selectedProduct.units == null) {
            await this.fetchProductsUnits([newSelectedProduct]);
          }

          const product = this.addProduct({
            product_id: selectedProduct.id,
            unit_id: selectedProduct.unit_id,
            cost_per_unit: selectedProduct.suppliers_price || 0,
            quantity: 1,
            supplier_code: "",
          });
          if (product) {
            newProducts.push(product);
          }
          this.props.setProducts(newProducts);
        }}
        customFilter={(p) =>
          p.type_of_product === "stocked" &&
          !p.is_deleted &&
          (p.has_components || p.components.length) &&
          !currentProductsIds.includes(p.id)
        }
      />
    );
  };
  handleQuantityChange = (newQuantity, record) => {
    const { products } = this.props;
    const newProducts = [...products];

    const newProduct = newProducts.find((r) => r.id === record.id);
    newProduct.quantity = Number(newQuantity);
    newProduct.converted_quantity =
      newProduct.quantity * (newProduct.conversion_factor || 1);
    // newProduct.components.forEach((component) => {
    //   component.quantity = component.required_amount * newProduct.quantity;
    // });

    this.props.setProducts(newProducts);
  };
  renderColumnUnit = (unit, record, index) => {
    const { t, config, editMode } = this.props;
    if (!unit) {
      return "-";
    }

    if (!editMode) {
      return (
        (config.language === "arabic" && record.unit?.unit__ar_name) ||
        record.unit?.unit__name
      );
    }
    let productUnits = [];
    if (record.baseUnit?.id) {
      productUnits.push(
        <Option key={record.baseUnit?.id} value={record.baseUnit?.id}>
          {(config.language === "arabic" && record.baseUnit.ar_name) ||
            record.baseUnit.name}
        </Option>,
      );
    }
    record.units?.forEach((unit) => {
      const unitName =
        config.language == "arabic"
          ? unit.unit__ar_name || unit.unit__name
          : unit.unit__name;

      productUnits.push(
        <Option value={unit.unit_id} key={unit.unit_id}>
          {unitName}
        </Option>,
      );
    });
    return productUnits.length > 1 ? (
      <Select
        style={{ width: "100%" }}
        placeholder={t("select a unit ")}
        value={unit?.unit_id}
        onSelect={(unitId) => {
          const newProducts = [...this.props.products];
          const unit =
            record.units.find((u) => u.unit_id === unitId) || record.baseUnit;
          newProducts[index].unit = unit;
          newProducts[index].unit_id = unit["unit_id"];
          newProducts[index].conversion_factor = unit.conversion_factor;
          newProducts[index].converted_quantity =
            unit.conversion_factor * newProducts[index].quantity;
          this.props.setProducts(newProducts);
        }}
      >
        {productUnits}
      </Select>
    ) : (
      <span>
        {(config.language === "arabic" &&
          (record.units?.[0] || record.baseUnit)?.unit__ar_name) ||
          (record.units?.[0] || record.baseUnit)?.unit__name ||
          "-"}
      </span>
    );
  };
  render() {
    const {
      t,
      products,
      selectedOrder,
      settings,
      config,
      permissions,
      editMode,
      isViewOnly,
    } = this.props;

    const { excelModalOpen } = this.state;
    return (
      <div>
        {excelModalOpen && (
          <InventoryExcelUploader
            visible={excelModalOpen}
            selectedOrder={selectedOrder}
            type={"production_order"}
            onClose={async (shouldRefetch, newTotal) => {
              this.setState({ excelModalOpen: false });
              if (shouldRefetch) {
                await this.props.fetchProductionOrderDetails();
              }
            }}
          />
        )}
        {!editMode &&
          !isViewOnly &&
          permissions.can_update_production_orders &&
          selectedOrder.status === "New" && (
            <div
              style={{
                display: "flex",
                gap: 16,
                float: (config.language === "arabic" && "left") || "right",
              }}
            >
              <Button
                icon={<EditOutlined />}
                onClick={() => this.props.setEditMode(true)}
                className="my-2"
                style={{
                  float: (config.language === "arabic" && "left") || "right",
                }}
              >
                {t("Add / Edit")}
              </Button>

              <Button
                icon={
                  <DownloadOutlined style={{ position: "relative", top: -2 }} />
                }
                onClick={() => {
                  this.setState({ excelModalOpen: true });
                }}
                className="my-2"
              >
                {t("Import")}
              </Button>
            </div>
          )}

        <Table
          id="print"
          columns={this.columns}
          dataSource={
            editMode ? [...products, { type: "New", units: [] }] : products
          }
          pagination={false}
          rowClassName={(record, index) =>
            record.is_deleted ? "d-none" : "text-center editable-row"
          }
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
          expandable={{
            childrenColumnName: !editMode && "components",

            indentSize: 30,
            defaultExpandAllRows: false,
          }}
          className="my-3"
        >
          <Column
            title={t("Product")}
            key="product_id"
            dataIndex={"product_id"}
            render={(productId, record, index) =>
              this.renderColumnProduct(productId, record, index)
            }
          />
          <Column
            title={t("Quantity")}
            dataIndex="quantity"
            key="quantity"
            render={(quantity, record, index) => {
              return (
                quantity ||
                record.required_amount *
                  (products.find((p) => p.id === record.parent_id)
                    ?.converted_quantity || 1)
              );
            }}
            onCell={(record, index) => ({
              record,
              editable: editMode && !record.parent_id,
              value: record.quantity,
              handleSave: (newQuantity) => {
                if (newQuantity >= 0 && !Number.isNaN(newQuantity)) {
                  this.handleQuantityChange(newQuantity, record);
                }
              },
            })}
          />
          <Column
            title={t("Unit")}
            dataIndex={"unit"}
            key="unit"
            render={(unit, record, index) =>
              this.renderColumnUnit(unit, record, index)
            }
          />

          {selectedOrder.status === "New" && !editMode && (
            <Column
              title={t("Available Quantity")}
              dataIndex="available_inventory"
              key="available_inventory"
            />
          )}
          {editMode && (
            <Column
              title={t("Delete")}
              key="delete"
              render={this.renderColumnDelete}
            />
          )}
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
    allProducts: state.products.allProducts,
    units: state.products.units,
  };
};
const mapDispatchToProps = (dispatch) => {
  return { setProductsUnits: (payload) => dispatch(setProductsUnits(payload)) };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(ProductionOrderProductsTable));
